import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import {
  createBrowserRouter,
  RouterProvider,
  useLocation,
} from 'react-router-dom';
import { NavigationProvider } from './features/navigation/NavigationProvider';
import reportWebVitals from './reportWebVitals';
import { FeedbackProvider } from './features/feedback/FeedbackProvider';
import { CssBaseline, ThemeProvider } from '@mui/material';
import { theme } from './theme';
import { AppUpdatePrompt } from './components/ui/AppUpdatePrompt';
import { AppLoadingScreen } from './components/ui/AppLoadingScreen';
const DesignPreview =
  process.env.NODE_ENV === 'development'
    ? React.lazy(() => import('./dev/DesignPreview'))
    : null;
const NavigationPreview =
  process.env.NODE_ENV === 'development'
    ? React.lazy(() => import('./dev/NavigationPreview'))
    : null;

// Kept out of the main bundle: demo code and data load only on /try.
const DemoApp = React.lazy(() => import('./features/demo/DemoApp'));
const isDemoPath = (pathname: string) => /^\/try(\/|$)/.test(pathname);

function Root() {
  const { pathname } = useLocation();
  return isDemoPath(pathname) ? (
    <React.Suspense fallback={<AppLoadingScreen />}>
      <DemoApp />
    </React.Suspense>
  ) : (
    <App />
  );
}

const router = createBrowserRouter([
  {
    path: '*',
    element: (
      <NavigationProvider>
        {NavigationPreview &&
        window.location.pathname.startsWith('/navigation-preview') ? (
          <React.Suspense fallback={null}>
            <NavigationPreview />
          </React.Suspense>
        ) : DesignPreview && window.location.pathname === '/design-preview' ? (
          <React.Suspense fallback={null}>
            <DesignPreview />
          </React.Suspense>
        ) : (
          <Root />
        )}
      </NavigationProvider>
    ),
  },
]);

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement,
);
root.render(
  <React.StrictMode>
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <FeedbackProvider>
        <RouterProvider router={router} />
        <AppUpdatePrompt />
      </FeedbackProvider>
    </ThemeProvider>
  </React.StrictMode>,
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
